// Canonical alias for the exact BFF Classic v3 stadium captured in replay
// statistics. Keep one map object so Gym and map regression tests cannot drift.
import { bffClassic } from './bffClassic';

export const bffClassicV3 = bffClassic;
export default bffClassicV3;
